import { commandDefinition, optionsDefinition } from "../../Commons/Options/CommandBasedOptionsParser";
import { CommonOptions } from "../CommonOptions/CommonOptions";
import { devModeOption, logVerbosityOption } from "../CommonOptions/CommonOptionDefintions";

export interface FormStatsOptions extends CommonOptions {
    formGlobs: string[];
    byEngine: boolean;
}

export const formStatsCommandDefinition = commandDefinition<"form-stats", FormStatsOptions>(
    "form-stats",
    "form-stats",
    optionsDefinition(
        {
            alias: "g",
            name: "gfvs",
            defaultValue: { formGlobs: [] },
            parse: (input: string[]) => ({ formGlobs: input }),
            defaultOption: true,
            multiple: true,
            description: "Одна или несколько GFV или GFV-масок для пересобрки.",
        },
        {
            name: "by-engine",
            doesNotRequireValue: true,
            defaultValue: { byEngine: false },
            parse: (x: boolean) => ({ byEngine: x }),
            description: "Показать статискиу пе версиям движка.",
        },
        devModeOption,
        logVerbosityOption
    ),
    {
        description:
            "Выполняет сборку одной или нескольких форм.\n" +
            "Подробнее: https://git.skbkontur.ru/forms/candy/-/blob/master/Tools/README.md#candy-form-stats",
    }
);
